import {useState} from "react";
import "./works.scss";

export default function Works(){
    const [currentSlide, setCurrentSlide] = useState(0);

    const data = [
        {
          id: "1",
          icon: "./assets/mobile.png",
          title: "Tech Active Solutions Private Limited",
          desc:
            "Feb 2019 - Present",
          img:
            "./assets/ta.png",
          link:'https://www.active.agency/'
        },
        {
          id: "1",
          icon: "./assets/mobile.png",
          title: "Kreative Digital Solution Pvt Ltd",
          desc:
            "Sep 2018 - Jan 2019",
          img:
            "./assets/kds.png",
          link:'https://www.kreativedigitalsolution.com/'
        },
      ];

      const handleClick = (way) => {
        way === "left" ? setCurrentSlide(currentSlide > 0 ? currentSlide-1 : 2) : 
        setCurrentSlide(currentSlide < data.length-1 ? currentSlide+1 : 0);
      }


    return(
        <div className="works" id="works">
            <div className="slider" style={{transform:`translateX(-${currentSlide * 100}vw)`}}>
                {
                    data.map((d) => {
                        return(
                            <div className="container">
                                <div className="item">
                                    <div className="left">
                                        <div className="leftContainer">
                                            <div className="imgContainer">
                                                <img src={d.icon} alt="" srcset="" />
                                            </div>
                                            <h2>{d.title}</h2>
                                            <p>
                                                {d.desc}
                                            </p>
                                            <span> <a href={d.link} target="_blank">Company Website</a></span>
                                        </div>
                                    </div>
                                    <div className="right">
                                        <img src={d.img} alt="" srcset="" />
                                    </div>
                                </div>
                            </div>
                        );
                    })
                }
            </div>

            <img src="assets/arrow.png" alt="arrow" srcset="" className="arrow left" onClick={() => handleClick("left")}/>
            <img src="assets/arrow.png" alt="arrow" srcset="" className="arrow right" onClick={() => handleClick("right")}/>

        </div>
    )
}